var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOwner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 13.7632V12.2895C1 11.5078 1.31607 10.7581 1.87868 10.2054C2.44129 9.65263 3.20435 9.34211 4 9.34211H5.125M11.65 13.1737L13 14.5M2.5 3.44737C2.5 4.22906 2.81607 4.97873 3.37868 5.53147C3.94129 6.08421 4.70435 6.39474 5.5 6.39474C6.29565 6.39474 7.05871 6.08421 7.62132 5.53147C8.18393 4.97873 8.5 4.22906 8.5 3.44737C8.5 2.66568 8.18393 1.916 7.62132 1.36326C7.05871 0.810525 6.29565 0.5 5.5 0.5C4.70435 0.5 3.94129 0.810525 3.37868 1.36326C2.81607 1.916 2.5 2.66568 2.5 3.44737ZM7.75 11.5526C7.75 12.1389 7.98705 12.7012 8.40901 13.1157C8.83097 13.5303 9.40326 13.7632 10 13.7632C10.5967 13.7632 11.169 13.5303 11.591 13.1157C12.0129 12.7012 12.25 12.1389 12.25 11.5526C12.25 10.9664 12.0129 10.4041 11.591 9.98955C11.169 9.575 10.5967 9.34211 10 9.34211C9.40326 9.34211 8.83097 9.575 8.40901 9.98955C7.98705 10.4041 7.75 10.9664 7.75 11.5526Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOwner);
export default __webpack_public_path__ + "static/media/owner.3c8d522b3161b083d7ef1fc8963b2135.svg";
export { ForwardRef as ReactComponent };